import React from 'react';
import { PRICES, formatPrice, type PriceItem } from '../config/business';

interface PriceTableProps {
  /** Catégories à afficher (toutes par défaut). */
  categories?: PriceItem['category'][];
  caption?: string;
  className?: string;
}

/** Tableau des tarifs « à partir de », alimenté par src/config/business.ts. */
const PriceTable: React.FC<PriceTableProps> = ({ categories, caption, className = '' }) => {
  const items = categories ? PRICES.filter((p) => categories.includes(p.category)) : PRICES;

  return (
    <div className={`overflow-hidden rounded-xl border border-gray-700 ${className}`}>
      <table className="w-full text-sm">
        {caption && <caption className="sr-only">{caption}</caption>}
        <thead className="bg-[#2F3136] text-left text-gray-400">
          <tr>
            <th scope="col" className="px-4 py-3 font-medium">Prestation</th>
            <th scope="col" className="px-4 py-3 font-medium text-right">Tarif</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-700">
          {items.map((item) => (
            <tr key={item.id} className="bg-[#36393F]">
              <td className="px-4 py-3 text-gray-200">{item.label}</td>
              <td className="px-4 py-3 text-right font-semibold text-white whitespace-nowrap">{formatPrice(item)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PriceTable;
